import { CategoryData } from '../../../../types/types';

export const salutations: CategoryData = {
    // Salutations de base - CONFIRMÉES
    'Mbote (Bonjour)': {
        translation: 'Bonjour',
        translationEn: 'Hello',
        illustration: '👋',
        audio: 'Li-mbote'
    },
    'Mbote ya ntongo (Bonjour le matin)': {
        translation: 'Bonjour (le matin)',
        translationEn: 'Good morning',
        illustration: '🌅',
        audio: 'Li-mbote_ya_ntongo'
    },
    'Mbote ya mpokwa (Bonsoir)': {
        translation: 'Bonsoir',
        translationEn: 'Good evening',
        illustration: '🌙',
        audio: 'Li-mbote_ya_mpokwa'
    },
    'Kende malamu (Au revoir)': {
        translation: 'Au revoir',
        translationEn: 'Goodbye',
        illustration: '👋',
        audio: 'Li-kende_malamu'
    },
    'Tikala malamu (À bientôt)': {
        translation: 'À bientôt / Reste bien',
        translationEn: 'See you soon / Take care',
        illustration: '🤝',
        audio: 'Li-tikala_malamu'
    },
    'Butu malamu (Bonne nuit)': {
        translation: 'Bonne nuit',
        translationEn: 'Good night',
        illustration: '🌙',
        audio: 'Li-butu_malamu'
    },

    // Remerciements et politesse - CORRIGÉS
    'Natondi yo (Merci)': {
        translation: 'Merci',
        translationEn: 'Thank you',
        illustration: '🙏',
        audio: 'Li-natondi_yo'
    },
    'Matondi mingi (Merci beaucoup)': {
        translation: 'Merci beaucoup',
        translationEn: 'Thank you very much',
        illustration: '🙏',
        audio: 'Li-matondi_mingi'
    },
    'Nasengi (S\'il vous plaît)': {
        translation: 'S\'il vous plaît',
        translationEn: 'Please',
        illustration: '🤲',
        audio: 'Li-nasengi'
    },
    'Bolimbisi (Pardon)': {
        translation: 'Pardon / Excusez-moi',
        translationEn: 'Sorry / Excuse me',
        illustration: '🙇',
        audio: 'Li-bolimbisi'
    },
    'Nasengi bolimbisi (Pardonnez-moi)': {
        translation: 'Pardonnez-moi',
        translationEn: 'Forgive me',
        illustration: '🙇‍♂️',
        audio: 'Li-nasengi_bolimbisi'
    },

    // Questions et réponses de base - VÉRIFIÉES
    'Ozali malamu? (Comment vas-tu?)': {
        translation: 'Comment vas-tu?',
        translationEn: 'How are you?',
        illustration: '😊',
        audio: 'Li-ozali_malamu'
    },
    'Nazali malamu (Je vais bien)': {
        translation: 'Je vais bien',
        translationEn: 'I am fine',
        illustration: '👍',
        audio: 'Li-nazali_malamu'
    },
    'Nazali malamu te (Je ne vais pas bien)': {
        translation: 'Je ne vais pas bien',
        translationEn: 'I am not well',
        illustration: '👎',
        audio: 'Li-nazali_malamu_te'
    },
    'Na yo? (Et toi?)': {
        translation: 'Et toi?',
        translationEn: 'And you?',
        illustration: '🤔',
        audio: 'Li-na_yo'
    },
    'Sango nini? (Quelles nouvelles?)': {
        translation: 'Quelles nouvelles?',
        translationEn: 'What\'s new?',
        illustration: '📰',
        audio: 'Li-sango_nini'
    },
    'Nsango te (Pas de nouvelles)': {
        translation: 'Pas de nouvelles / Rien de spécial',
        translationEn: 'No news / Nothing special',
        illustration: '🤷',
        audio: 'Li-nsango_te'
    },

    // Présentations - CONFIRMÉES
    'Kombo na yo nani? (Comment t\'appelles-tu?)': {
        translation: 'Comment t\'appelles-tu?',
        translationEn: 'What is your name?',
        illustration: '🤔',
        audio: 'Li-kombo_na_yo_nani'
    },
    'Kombo na ngai ezali (Je m\'appelle)': {
        translation: 'Je m\'appelle',
        translationEn: 'My name is',
        illustration: '👤',
        audio: 'Li-kombo_na_ngai_ezali'
    },
    'Esengo ya koyeba yo (Enchanté)': {
        translation: 'Enchanté(e) de te connaître',
        translationEn: 'Nice to meet you',
        illustration: '🤝',
        audio: 'Li-esengo_ya_koyeba_yo'
    },
    'Owuti wapi? (D\'où viens-tu?)': {
        translation: 'D\'où viens-tu?',
        translationEn: 'Where are you from?',
        illustration: '🌍',
        audio: 'Li-owuti_wapi'
    },

    // Souhaits - SIMPLIFIÉS
    'Mokolo malamu (Bonne journée)': {
        translation: 'Bonne journée',
        translationEn: 'Have a good day',
        illustration: '☀️',
        audio: 'Li-mokolo_malamu'
    },
    'Kolia malamu (Bon appétit)': {
        translation: 'Bon appétit',
        translationEn: 'Enjoy your meal',
        illustration: '🍽️',
        audio: 'Li-kolia_malamu'
    },

    // Expressions de respect - BASIQUES
    'Mbote na bino (Bonjour à vous)': {
        translation: 'Bonjour à vous (pluriel / respect)',
        translationEn: 'Hello to you (plural / respectful)',
        illustration: '🙋‍♂️',
        audio: 'Li-mbote_na_bino'
    },
    'Tata (Monsieur)': {
        translation: 'Monsieur / Papa',
        translationEn: 'Sir / Father',
        illustration: '👨',
        audio: 'Li-tata'
    },
    'Mama (Madame)': {
        translation: 'Madame / Maman',
        translationEn: 'Madam / Mother',
        illustration: '👩',
        audio: 'Li-mama'
    },

    // Expressions d'accueil - SIMPLIFIÉES
    'Boyei malamu (Bienvenue)': {
        translation: 'Bienvenue',
        translationEn: 'Welcome',
        illustration: '🏠',
        audio: 'Li-boyei_malamu'
    }
};

export default salutations;
